import { useState } from "react";
import { toast } from "sonner";
import { BookOpen, ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import { KAJABI } from "@/lib/data";

export default function EbookRibbon() {
 const [email, setEmail] = useState("");
 const [sent, setSent] = useState(false);

 const onSubmit = (e) => {
 e.preventDefault();
 if (!email) {
 toast.error("Drop your email to grab the guide.");
 return;
 }
 setSent(true);
 toast.success("Opening your free guide...");
 setTimeout(() => {
 window.open(KAJABI.ebook, "_blank", "noopener,noreferrer");
 }, 500);
 };

 return (
 <section
 data-testid="ebook-ribbon"
 className="relative bg-ink-800 border-y border-ink-600 overflow-hidden"
 >
 <div className="absolute inset-0 bg-gradient-to-r from-amber/5 via-transparent to-amber/5 pointer-events-none" />

 <motion.div
 initial={{ opacity: 0, y: 20 }}
 whileInView={{ opacity: 1, y: 0 }}
 viewport={{ once: true }}
 transition={{ duration: 0.5 }}
 className="relative max-w-7xl mx-auto px-4 md:px-8 py-12 md:py-16 grid md:grid-cols-12 gap-8 items-center"
 >
 <div className="md:col-span-7">
 <div className="flex items-center gap-3 mb-3">
 <BookOpen size={18} className="text-amber" />
 <span className="font-mono text-xs uppercase tracking-[0.25em] text-amber font-semibold">
 Free · No strings
 </span>
 </div>
 <h3 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold tracking-normal leading-[1.15]">
 Not ready to commit?{" "}
 <span className="text-amber italic">Start free.</span>
 </h3>
 <p className="mt-4 text-white/65 text-base md:text-lg max-w-xl">
 Grab the <span className="text-white font-semibold">Survival Guide for Sync</span>. Our initial set-up and music business primer for indie creators.
 </p>
 </div>

 <form
 onSubmit={onSubmit}
 data-testid="ebook-ribbon-form"
 className="md:col-span-5 flex flex-col sm:flex-row gap-2"
 >
 <input
 type="email"
 required
 value={email}
 onChange={(e) => setEmail(e.target.value)}
 placeholder="you@yourmusic.com"
 data-testid="ebook-ribbon-input"
 disabled={sent}
 className="flex-1 bg-ink-900 border border-ink-600 focus:border-amber text-white px-5 py-4 rounded-sm text-sm font-medium placeholder:text-white/40 focus:outline-none transition-colors disabled:opacity-60"
 />
 <button
 type="submit"
 data-testid="ebook-ribbon-submit"
 disabled={sent}
 className="flex-shrink-0 inline-flex items-center justify-center gap-2 bg-amber hover:bg-amber-hover text-black font-bold uppercase tracking-wider text-xs px-6 py-4 rounded-sm transition-all group disabled:opacity-70"
 >
 {sent ? "Opening..." : "Send Guide"}
 <ArrowRight
 size={14}
 className="transition-transform group-hover:translate-x-1"
 />
 </button>
 </form>
 </motion.div>
 </section>
 );
}
